import { useEffect, useState } from "react";
import { ArrowRight, ExternalLink } from "lucide-react";
import DeveloperLogo from "../components/DeveloperLogo";
import api from "../lib/api";
import { useApp } from "../context/AppContext";
import SectionHeading from "../components/SectionHeading";

export default function Developers() {
  const { openLead } = useApp();
  const [devs, setDevs] = useState([]);
  useEffect(() => { api.developers().then(setDevs).catch(() => {}); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
      <SectionHeading eyebrow="Builders" title="Trusted Developers & Builders"
        subtitle="Established names with a track record of quality delivery and RERA compliance."
        action={<button onClick={() => openLead({ type: "callback", title: "List Your Project" })} data-testid="list-project-btn" className="inline-flex items-center gap-2 pbs-gradient text-white font-bold px-5 py-2.5 rounded-xl text-sm">List Your Project</button>} />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {devs.map((d) => (
          <div key={d.slug} data-testid={`developer-${d.slug}`} className="bg-white rounded-2xl border border-pbs-line p-6 pbs-shadow hover:pbs-shadow-hover transition-shadow">
            <DeveloperLogo dev={d} className="h-28" />
            <div className="mt-4 flex items-center justify-between gap-2">
              <h3 className="font-bold text-lg text-pbs-dark leading-tight">{d.name}</h3>
              {d.website && <a href={d.website} target="_blank" rel="noreferrer" data-testid={`dev-site-${d.slug}`} className="inline-flex items-center gap-1 text-xs font-semibold text-pbs-purple shrink-0">Website <ExternalLink size={12} /></a>}
            </div>
            {d.featured_projects?.length > 0 && (
              <div className="mt-3">
                <p className="text-[11px] font-semibold uppercase tracking-wide text-pbs-grey mb-1.5">Featured Projects</p>
                <div className="flex flex-wrap gap-1.5">{d.featured_projects.map((f) => <span key={f} className="text-[11px] bg-pbs-bg border border-pbs-line px-2 py-0.5 rounded-full text-pbs-dark/80">{f}</span>)}</div>
              </div>
            )}
            <button onClick={() => openLead({ type: "enquiry", title: `Developer: ${d.name}` })} className="mt-5 w-full flex items-center justify-center gap-1.5 text-sm font-bold text-pbs-purple border border-pbs-purple/30 rounded-lg py-2.5 hover:bg-pbs-purple/5 transition-colors">Explore Projects <ArrowRight size={15} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
